import { Component, OnInit } from '@angular/core';
import { Child } from 'src/app/shared/interfaces/child.interface';
import { ChildService } from '../services/child.service';

@Component({
  selector: 'app-chilren-list',
  templateUrl: './chilren-list.component.html',
  styleUrls: ['./chilren-list.component.css'],
})
export class ChilrenListComponent implements OnInit {
  children: Child[] = [];
  searchValue: string = '';

  constructor(private childService: ChildService) {}

  ngOnInit(): void {
    this.getAllChild();
  }
  ngAfterViewInit(): void {}

  getAllChild() {
    this.childService.get().then((res) => {
      this.children = res;
    });
  }

  search(value) {
    this.childService.searchChild(value).then((res) => {
      this.children = res;
    });
  }
}
